import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // Para navegação, se você usa react-router-dom

const Privacidade = () => {
  const content = `<h1 class="text-4xl font-bold text-gray-900 mb-6">Termos de Uso e Política de Privacidade</h1><p class="text-lg text-gray-700 mb-4"><strong>Última atualização: Março de 2025</strong></p><h2 class="text-2xl font-semibold text-gray-900 mb-4">1. Introdução</h2><p class="text-lg text-gray-700 mb-4">A Vazô é uma plataforma digital especializada na detecção e notificação de vazamentos de credenciais corporativas expostas na web, deep web e dark web. Nosso compromisso é oferecer um serviço seguro e confiável, garantindo conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018) e demais regulamentações aplicáveis.</p><h2 class="text-2xl font-semibold text-gray-900 mb-4">2. Aceitação dos Termos</h2><p class="text-lg text-gray-700 mb-4">Ao utilizar nossos serviços, o usuário declara estar ciente e de acordo com os termos e condições estabelecidos neste documento. Reservamo-nos o direito de modificar esta política a qualquer momento, sendo a versão atualizada sempre disponibilizada em nosso site.</p><h2 class="text-2xl font-semibold text-gray-900 mb-4">3. Coleta e Uso de Dados</h2><p class="text-lg text-gray-700 mb-4">A Vazô coleta e processa dados exclusivamente para a prestação dos serviços contratados. Isso inclui credenciais corporativas expostas, informações de contato fornecidas pelo usuário e registros de acesso à plataforma. Esses dados são utilizados para monitoramento e notificação de vazamentos, segurança da informação e cumprimento de obrigações legais. Em nenhuma circunstância vendemos, compartilhamos ou utilizamos os dados coletados para finalidades não autorizadas.</p><h2 class="text-2xl font-semibold text-gray-900 mb-4">4. Base Legal para o Tratamento de Dados</h2><p class="text-lg text-gray-700 mb-4">O tratamento de dados realizado pela Vazô fundamenta-se em bases legais da LGPD, como cumprimento de obrigações regulatórias, proteção do titular dos dados, legítimo interesse e, quando necessário, consentimento.</p><h2 class="text-2xl font-semibold text-gray-900 mb-4">5. Segurança e Armazenamento de Dados</h2><p class="text-lg text-gray-700 mb-4">A segurança das informações é uma prioridade, adotando medidas técnicas e organizacionais rigorosas para prevenir acessos indevidos, vazamentos e qualquer uso indevido dos dados. Os dados armazenados são protegidos por criptografia e outras tecnologias de segurança.</p><h2 class="text-2xl font-semibold text-gray-900 mb-4">6. Direitos dos Titulares dos Dados</h2><p class="text-lg text-gray-700 mb-4">Os titulares dos dados podem exercer seus direitos previstos na LGPD, incluindo o acesso, correção, anonimização ou exclusão de informações. Para isso, basta entrar em contato com nossa equipe pelo e-mail informado abaixo. Caso o usuário deseje a exclusão de seus dados, a Vazô se compromete a atender à solicitação, salvo quando houver obrigação legal para retenção.</p><h2 class="text-2xl font-semibold text-gray-900 mb-4">7. Disposições Jurídicas</h2><p class="text-lg text-gray-700 mb-4">Operamos em conformidade com a legislação brasileira e, em caso de litígio, o foro competente será o da comarca de Franca/SP.</p><h2 class="text-2xl font-semibold text-gray-900 mb-4">8. Informações de Contato</h2><p class="text-lg text-gray-700 mb-4"><strong>Razão Social:</strong> Vazô<br><strong>CNPJ:</strong> 59.643.373/0001-23<br><strong>Endereço:</strong> Rua Itargino da Cruz de Andrade, nº 2245, Residencial Palermo, Franca/SP, CEP 14408-072<br><strong>E-mail para contato:</strong> vazomonitoramento@gmail.com</p><p class="text-lg text-gray-700 mt-6">Este documento reflete nosso compromisso com a transparência, segurança e proteção de dados, garantindo conformidade com a LGPD e demais normativas aplicáveis.</p>`; 

  return (
    <div className="font-sans bg-white min-h-screen overflow-x-hidden">
      {/* Header */}
      <motion.header
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className="fixed w-full bg-white/90 backdrop-blur-md z-50 shadow-sm border-b border-gray-100"
      >
        <div className="container mx-auto px-4 lg:px-8 py-3 flex justify-between items-center">
          <Link to="/">
            <motion.div whileHover={{ scale: 1.05 }}>
              <img
                src="./vazo-png-logo.png"
                alt="Vazô Logo"
                className="h-6 lg:h-6 w-auto"
              />
            </motion.div>
          </Link>
          <Link to="/login">
            <motion.button
              whileHover={{ scale: 1.05 }}
              className="bg-emerald-600 text-white px-4 py-2 rounded-lg font-medium"
            >
              Login
            </motion.button>
          </Link>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <main className="pt-24 pb-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div
            className="prose prose-lg max-w-4xl mx-auto"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          <div className="mt-8 flex justify-center">
            <Link to="/">
              <motion.button
                whileHover={{ scale: 1.05 }}
                className="bg-emerald-600 text-white px-6 py-3 rounded-lg font-medium"
              >
                Voltar para Home
              </motion.button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <img
                src="./vazo-png-logo-invertido.png"
                alt="Logo"
                className="h-8 mb-4"
              />
              <p className="text-sm">Proteção inteligente contra vazamentos de dados</p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">Sobre</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-white transition-colors">@vazo.info</a></li>
                <li><a href="#" className="hover:text-white transition-colors">contato@vazo.info</a></li>
                <li><a href="#" className="hover:text-white transition-colors">+55 16 99437-9993</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">Legal</h3>
              <ul className="space-y-2">
                <li><a href="/politicas-de-privacidade" className="hover:text-white transition-colors">Privacidade</a></li>
                <li><a href="/lgpd" className="hover:text-white transition-colors">LGPD</a></li>
                <li><a href="#" className="hover:text-white transition-colors">59.643.373/0001-23</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">Recursos</h3>
              <ul className="space-y-2">
                <li><a href="/blog" className="hover:text-white transition-colors">Blog</a></li>
                <li><a href="/uptime" className="hover:text-white transition-colors">Status</a></li>
                <li><a href="/login" className="hover:text-white transition-colors">Login</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm">
            © {new Date().getFullYear()} Vazô. Todos os direitos reservados.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Privacidade;